import HttpHelpers from '../helpers';

const ReportingApiEndpoints = {
  getStatistics: () => {
    return HttpHelpers.authenticatedAxios
      .get('host/statistics')
      .then((response) => response.data);
  },
  getPayments: (params) => {
    return HttpHelpers.authenticatedAxios
      .get('host/payment', { params })
      .then((response) => response.data);
  },
  getPaymentDetails: (paymentId) => {
    return HttpHelpers.authenticatedAxios
      .get(`host/payment/${paymentId}`)
      .then((response) => response.data);
  },
  getPayouts: (params) => {
    return HttpHelpers.authenticatedAxios
      .get('host/payout', { params })
      .then((response) => response.data);
  },
};

export default ReportingApiEndpoints;
